<template>
  <div class="color-theme-button">
    <p class="color-theme-button__ttl">
      <SunIcon class="color-theme-button__sun" /> Тема
    </p>
    <div class="color-theme-button__btns" ref="buttonsRef">
      <div class="color-theme-button__caret" :style="caretStyle"></div>
      <button
        v-for="(icon, index) in ICONS"
        :key="index"
        class="color-theme-button__icon"
        :class="{ 'color-theme-button__icon--active': selectedIndex === index }"
        @click="selectTheme(index)"
        ref="themeButtons"
      >
        <component :is="icon" />
      </button>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, nextTick } from 'vue';
  import { useStore } from 'vuex';
  //-----------------------------------
  import SunIcon from '@/Groups/ColorThemesManager/private/svg/SunIcon.vue';
  import LightThemeIcon from '@/Groups/ColorThemesManager/private/svg/LightThemeIcon.vue';
  import DarkThemeIcon from '@/Groups/ColorThemesManager/private/svg/DarkThemeIcon.vue';
  import BlueThemeIcon from '@/Groups/ColorThemesManager/private/svg/BlueThemeIcon.vue';
  //-----------------------------------
  const store = useStore();
  //-----------------------------------
  const ICONS = [LightThemeIcon, DarkThemeIcon, BlueThemeIcon];
  const THEME_NAMES = ['light', 'dark', 'blue'];
  //-----------------------------------
  //Хранит коллекцию DOM-элементов кнопок выбора темы
  const themeButtons = ref([]);
  //Ссылка на корневой элемент контейнера кнопок
  const buttonsRef = ref(null);
  /*
    Строковое значение (например, "32px"), определяющее горизонтальное положение каретки (индикатора выбранной темы) 
    относительно левого края контейнера кнопок.
  */
  const caretLeft = ref('0px');
  //-----------------------------------
  onMounted(() => {
    initThemeButtons();
    updateCaret();
  });
  //-----------------------------------
  //Возвращает индекс текущей темы в массиве THEME_AMES, синхронизируя UI с состоянием Vuex хранилища
  const selectedIndex = computed(() => {
    return THEME_NAMES.indexOf(store.state.ColorThemesManager.currentTheme);
  });

  //Возвращает объект стилей для каретки, подставляя значение caretLeft в CSS-свойство left
  const caretStyle = computed(() => ({ left: caretLeft.value }));
  //-----------------------------------
  //Инициализация DOM-элементов кнопок выбора темы
  const initThemeButtons = () => {
    themeButtons.value = buttonsRef.value.querySelectorAll('button');
  }

  //Вычисляет и обновляет позицию каретки, синхронизируя её с текущей выбранной темой
  const updateCaret = () => {
    nextTick(() => {
      const button = themeButtons.value[selectedIndex.value];
      if(!button) return;
      caretLeft.value = `${button.offsetLeft}px`;
    });
  };
  
  //Обработчик клика по кнопке темы
  const selectTheme = (index) => {
    store.dispatch('ColorThemesManager/setTheme', THEME_NAMES[index]);
    updateCaret();
  };
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>